import { render, staticRenderFns } from "./GlassesFrameList.vue?vue&type=template&id=827eeb5c&scoped=true&"
import script from "./GlassesFrameList.vue?vue&type=script&lang=js&"
export * from "./GlassesFrameList.vue?vue&type=script&lang=js&"
import style0 from "./GlassesFrameList.vue?vue&type=style&index=0&id=827eeb5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827eeb5c",
  null
  
)

export default component.exports